module.exports = __webpack_public_path__ + "img/9x16.75e877cf.svg";